import { render, staticRenderFns } from "./SupervisorPanel.vue?vue&type=template&id=4bdc113a&"
import script from "./SupervisorPanel.vue?vue&type=script&lang=js&"
export * from "./SupervisorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports